import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/img/bm1-bg-tr2.png'
import _imports_1 from '../../assets/img/behailu-mob.png'


const _hoisted_1 = { class: "w-screen h-screen flex flex-col md:flex-row align-middle md:justify-center" }
const _hoisted_2 = { class: "h-full w-full bg-white md:bg-[#403e3e] -z-20" }
const _hoisted_3 = { class: "flex flex-col w-full h-full py-10 bg-white text-[#6b6d70] text-left px-10 align-middle justify-center" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "my-4" }
const _hoisted_6 = { class: "gap-2" }
const _hoisted_7 = { class: "text-pinksh font-semibold" }
const _hoisted_8 = { class: "flex flex-wrap gap-2 w-fit" }
const _hoisted_9 = { class: "border-1 border-[#6b6d70] px-1 rounded-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_particles = _resolveComponent("vue-particles")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "desktop_img h-full w-fit mx-auto",
        src: _imports_0,
        alt: "profile picture"
      }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        class: "mobile_img mb-14 xxs:mb-0 p-1 rounded-full shadow w-10/12 m-auto",
        src: _imports_1,
        alt: "profile picture"
      }, null, -1)),
      _createVNode(_component_vue_particles, {
        id: "tsparticles",
        class: "absolute -z-10 hidden md:block",
        onParticlesLoaded: _ctx.particlesLoaded,
        options: {
          background: {},
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: 'push',
              },
              onHover: {
                enable: true,
                mode: 'repulse',
              },
            },
            modes: {
              bubble: {
                distance: 500,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: 'rgb(249 198 17)',
            },
            links: {
              color: 'rgb(249 198 17)',
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1,
            },
            move: {
              direction: 'none',
              enable: true,
              outModes: 'bounce',
              random: false,
              speed: 2,
              straight: false,
            },
            number: {
              density: {
                enable: true,
              },
              value: 100,
            },
            opacity: {
              value: 0.5,
            },

            shape: {
              type: 'circle',
            },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
        }
      }, null, 8, ["onParticlesLoaded"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "" }, [
        _createElementVNode("p", { class: "font-medium text-3xl tracking-tight fadeIn" }, [
          _createTextVNode(" HELLO! I'M "),
          _createElementVNode("span", { class: "text-pinksh uppercase" }, [
            _createElementVNode("strong", null, "Behailu Mesganaw")
          ])
        ]),
        _createElementVNode("p", { class: "font-semibold pb-7 xl:pb-5 text-lg lg:text-xl fadeIn" }, " a Full-Stack Developer based in Addis Ababa, Ethiopia, with a degree in Electrical and Computer Engineering. ")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.technicalSkills, (skill) => {
          return (_openBlock(), _createElementBlock("ul", {
            key: skill.name
          }, [
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(skill.name), 1),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.value, (value) => {
                    return (_openBlock(), _createElementBlock("div", { key: value }, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(value), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        }), 128))
      ]),
      _createVNode(_component_router_link, {
        to: "/about-me",
        class: "fadeIn bg-pinksh w-fit text-sm font-bold text-white hover:opacity-70 px-7 py-3 mt-4 rounded-full"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" More About Me ")
        ])),
        _: 1
      })
    ])
  ]))
}